export const toHumanList = (items: string[], lastJoin = " & "): string => {
  const elementWithoutLast = items.slice(0, -1);
  const lastElement = items[items.length - 1];
  const elementWithoutLastJoined = elementWithoutLast.join(", ");

  return [elementWithoutLastJoined, lastElement].filter(Boolean).join(lastJoin);
};
